module.exports = __webpack_public_path__ + "media/SOA/1. Banner - Inicio-7988f3f7.png";